import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import SecondLoader from "../SecondLoader";
import { MdClose } from "react-icons/md";
import FormInput from "../../components/Forms/FormInput";
import { Form } from "react-bootstrap";

const MemoryAddEditModal = ({
  loading,
  data,
  setSelectedData,
  handleSaveShowModal,
  handleCloseModal,
  show,
  error,
  setError,
}) => {
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setSelectedData({ ...data, [name]: value });
    // Clear error for this field if it exists
    if (error[name]) {
      setError((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name];
        return newErrors;
      });
    }
  };
  const handleFileChange = (files) => {
    setSelectedData({ ...data, medias: [...files] });
  };

  const handleAddUrl = async (e) => {
    handleSaveShowModal(data);
  };
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          handleCloseModal();
        }}
        className="customModal square-modal modal-dialog-scrollable"
        size="sm"
      >
        <Modal.Header className="modalHeader d-flex justify-content-between">
          <span className="modalHeading">
            {data?.id ? "Edit" : "Add"} Memory
          </span>
          <div className="modalGradientCircle"></div>
          <MdClose
            onClick={() => {
              handleCloseModal();
            }}
            className="modalCloseBtn"
          />
        </Modal.Header>
        {loading ? (
          <SecondLoader />
        ) : (
          <>
            <Modal.Body>
              <div className="container-fluid px-3">
                <div className="form-group">
                  <label className="form-label">Media Type</label>
                  <div className="d-flex gap-4">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="media_type"
                        value="audio"
                        onChange={handleChange}
                        checked={data?.media_type === "audio"}
                      />
                      <label className="form-check-label">Audio</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="media_type"
                        value="video"
                        onChange={handleChange}
                        checked={data?.media_type === "video"}
                      />
                      <label className="form-check-label">Video</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="media_type"
                        value="image"
                        onChange={handleChange}
                        checked={data?.media_type === "image"}
                      />
                      <label className="form-check-label">Image</label>
                    </div>
                  </div>
                  {error?.media_type ? (
                    <p className="errorText">{error?.media_type}</p>
                  ) : (
                    ""
                  )}
                </div>

                {/* <div className="form-group mb-3"> */}
                <FormInput
                  type="text"
                  label="Title"
                  placeholder="Enter Title"
                  name="title"
                  value={data?.title}
                  onChange={handleChange}
                  error={error?.title}
                />
                {/* {error.title ? (
                    <p className="errorText">{error.title}</p>
                  ) : (
                    ""
                  )}
                </div> */}

                <div className="form-group mb-3">
                  <FormInput
                    type="text"
                    label="Reminder"
                    placeholder="Enter reminder text"
                    name="reminder"
                    value={data.reminder}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="form-label">Choose Media File</label>
                  <div className="mediainput-group globalInputWithIcon">
                    <Form.Control
                      type="file"
                      name="medias"
                      onChange={(e) => handleFileChange(e.target.files)}
                      className="media"
                      multiple
                    />
                  </div>
                  {error?.medias ? (
                    <p className="errorText">{error?.medias}</p>
                  ) : (
                    ""
                  )}
                </div>

                <div className="form-group mb-2">
                  <label className="form-label">Save Type</label>
                  <div className="input-group globalInputWithIcon">
                    <select
                      className="form-select form-control"
                      name="save_type"
                      value={data.save_type}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select
                      </option>
                      <option value="uploaded">Uploaded</option>
                      {/* <option value="recorded">Recorded</option> */}
                    </select>
                  </div>
                  {error?.save_type ? (
                    <p className="errorText">{error?.save_type}</p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <div className="btnWrapper">
                <Button
                  type="button"
                  onClick={() => {
                    handleCloseModal();
                  }}
                  variant="outline-primary"
                  className="cancelBtn mx-3"
                >
                  Cancel
                </Button>

                <Button
                  type="button"
                  onClick={handleAddUrl}
                  className="saveBtn"
                >
                  Save
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
      <style type="">
        {`
          .form-check-label{
            color:#333333;
            font-size: 16px;
          }
        `}
      </style>
    </>
  );
};

export default MemoryAddEditModal;
